export default __webpack_public_path__ + "1e48f47873af05232d20d003b68fdecd.png";